// extracted by mini-css-extract-plugin
export default {"loading-spinner":"qBR21","loading-spinner-small":"vBpnN","spin":"ijS2Q","is-inverse":"hMpWQ"};